import React from "react";
import { Box, Grid, Container, Paper, Typography } from "@mui/material";
import Recognized from "./recognized";
import Unrecognized from "./unrecognized";
import { getToken } from "../authUtils";
import { baseURL } from "../http";
import moment from "moment";

export default function Admin() {
  const [recognizedData, setRecognizedData] = React.useState({});
  const [latestRecognized, setLatestRecognized] = React.useState(null);
  const [unrecognizedData, setUnrecognizedData] = React.useState({});
  const handleLatestRecognized = React.useCallback((data) => {
    setLatestRecognized(data);
  }, []);

  React.useEffect(() => {
    const token = getToken();
    const ws = new WebSocket(
      `${baseURL.replace(/^https/, "wss")}/checkin/ws/checkin`,
      [token]
    );
    ws.onmessage = function (e) {
      if (e.data) {
        try {
          const data = JSON.parse(e.data);
          if (data.is_recognized) {
            setRecognizedData(data);
          } else {
            setUnrecognizedData(data);
          }
        } catch (e) {}
      }
    };

    ws.onopen = () => {
      ws.send("ping");
    };

    ws.onerror = (e) => {
      console.log("err==>>", e);
    };

    ws.onclose = (info) => {
      console.log("info==>>", info);
    };
  }, []);

  return (
    <Container sx={{ marginTop: "20px", height: "100vh" }}>
      <Grid container spacing={2} sx={{ mb: 5 }}>
        <Grid item xs={12} md={7} style={{ height: "670px" }}>
          <Recognized
            insertData={recognizedData}
            onLatestRecognized={handleLatestRecognized}
          />
        </Grid>

        <Grid item xs={12} md={5} style={{ height: "670px" }}>
          <Box sx={{ height: "100%", minHeight: 0, display: "flex", flexDirection: "column" }}>
            <Typography sx={{ mb: 1, visibility: "hidden" }}>
              <strong>Recognized</strong>
            </Typography>
            <Box
              sx={{
                flex: 1,
                minHeight: 0,
                display: "grid",
                gridTemplateRows: "minmax(0, 1fr) minmax(0, 1fr)",
                gap: 2,
              }}
            >
              <Box sx={{ minHeight: 0 }}>
                <LatestRecognizedSummary data={latestRecognized} />
              </Box>
              <Box sx={{ minHeight: 0 }}>
                <Unrecognized insertData={unrecognizedData} />
              </Box>
            </Box>
          </Box>
        </Grid>
      </Grid>
    </Container>
  );
}

function LatestRecognizedSummary({ data }) {
  const name = [data?.first_name, data?.last_name].filter(Boolean).join(" ");
  const formattedTime = data?.checkin_time
    ? moment(data.checkin_time).format("h:mm a, Do MMM YYYY")
    : "";

  const details = [
    ["Status", data?.category],
    ["Member Id", data?.member_id],
    ["Remaining visits", data?.remaining_visits],
    ["Expiration date", data?.status_expiration_date],
    ["Optional A", data?.optional_a],
    ["Optional B", data?.optional_b],
  ].filter(([, value]) => value !== undefined && value !== null && value !== "");

  return (
    <Paper
      variant="outlined"
      sx={{
        height: "100%",
        boxSizing: "border-box",
        borderRadius: 1,
        overflow: "hidden",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <Box
        sx={{
          height: 72,
          background: "#0B0B45",
          color: "white",
          px: 2,
          display: "flex",
          alignItems: "center",
        }}
      >
        <Typography sx={{ fontWeight: 700 }}>Latest Recognized</Typography>
      </Box>
      {data ? (
        <Box sx={{ display: "flex", gap: 2, flex: 1, minHeight: 0, p: 2 }}>
          <Box
            component="img"
            src={data.image_s3_path}
            alt={name || "Latest recognized customer"}
            sx={{
              width: 170,
              height: 170,
              borderRadius: 1,
              objectFit: "cover",
              flex: "0 0 auto",
            }}
          />
          <Box sx={{ minWidth: 0, overflow: "auto", flex: 1 }}>
            <Typography
              variant="h6"
              sx={{ color: "#0B0B45", lineHeight: 1.2, fontSize: 24 }}
            >
              {name || "Unknown"}
            </Typography>
            {formattedTime && (
              <Typography
                variant="caption"
                color="text.secondary"
                sx={{ mt: 0.5, display: "block", fontSize: 16 }}
              >
                {formattedTime}
              </Typography>
            )}
            <Box
              sx={{
                display: "grid",
                gridTemplateColumns: "auto minmax(0, 1fr)",
                columnGap: 1.5,
                rowGap: 0.4,
                mt: 1.25,
              }}
            >
              {details.map(([label, value]) => (
                <React.Fragment key={label}>
                  <Typography
                    variant="caption"
                    color="text.secondary"
                    sx={{ fontSize: 14 }}
                  >
                    {label}
                  </Typography>
                  <Typography
                    variant="caption"
                    sx={{ fontSize: 14, overflowWrap: "anywhere" }}
                  >
                    {String(value)}
                  </Typography>
                </React.Fragment>
              ))}
            </Box>
          </Box>
        </Box>
      ) : (
        <Box
          sx={{
            flex: 1,
            m: 2,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            border: "1px dashed #d7d7d7",
            borderRadius: 1,
          }}
        >
          <Typography color="text.secondary" sx={{ fontSize: 16 }}>
            No recognized check-ins yet.
          </Typography>
        </Box>
      )}
    </Paper>
  );
}
